(function (app) {
  $(document).ready(function () {

    app.Billing = function () {

      var _this = this;
      var nameSpace = 'Billing',
        context = '.page__billing--container',
        invoiceTable = '.table__invoice-list',
        templates = {
          'invoiceRow': app.templates["Billing__billing____row"],
          'receipt': app.templates["Billing__billing____receipt"]
        },
        $receiptBody = $('#ReceiptModal .modal-content')
        ;

      // To update Table view
      _this.updateList = function (response) {
        // Clean up all existing data in dom
        var $invoiceBody = $('.table__invoice-body', $(context));
        $invoiceBody.html('');

        $(invoiceTable).removeClass('loading-state');

        if (typeof response != 'undefined') {
          _.each(response, function (row) {
            if(_.isObject(row)) {
              row.status = _.isUndefined(row.status) ? 'Paid' : row.status;

              var invoiceRow = _.template(templates.invoiceRow);
              var $invoiceRow = $(
                invoiceRow(
                  $.extend(row, {
                    'statusClass': row.status.toLowerCase()
                  })
                )
              );
              $invoiceRow.appendTo($invoiceBody);
            }

          });
        } else {
          $('.page__no--records').show();
        }
      };

      _this.getInvoices = function (options) {
        $(invoiceTable).addClass('loading-state');
        $('.page__no--records').hide();

        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {
          })
        ;
        appTransport.get('/api/billing/invoices');
        return query.promise();
      };

      /**
       * Update / Save Credit card
       * @returns {*}
       */
      _this.save = function () {
        var query = $.Deferred();
        var $billingForm = $('form[name="billing__form"]', $(context));
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $('[data-action=cancel-update-credit-card]', $(context)).trigger('click');
                app.redirect('/my-account/billing', true);
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          });

        var requestData = $('form[name="billing__form"]', $(context)).serializeObject();
        requestData.cardExpiryMonth = parseInt(requestData.cardExpiryMonth);
        if (requestData.cardExpiryMonth <= 9) {
          requestData.cardExpiryMonth = '0' + requestData.cardExpiryMonth;
        }
        requestData.cardExpiry = '20' + requestData.cardExpiryYear + '-' + requestData.cardExpiryMonth;
        requestData.cardNumber = requestData.cardNumber.replace(/ /g, '');
        appTransport.post('/api/billing/card-update', requestData);
        return query.promise();
      };

      /**
       *
       * @returns {*}
       */
      _this.cancelSubscription = function () {
        var query = $.Deferred();
        var requestData = $('form[name="cancel-account__form"]', $(context)).serializeObject();
        var $modal = $('#CancelAccountModal');
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $modal.modal('hide');
                if (requestData.delete_effective_date == 'end_of_billing_period') {
                  app.redirect('/my-account/billing', true);
                } else {
                  app.redirect('/my-account/logout', true);
                }

                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            if (typeof error.message != 'undefined' && error.message.message == 'downgradeError') {
              $('.cancel-account-error-body', $modal).removeClass('d-none');
              $('.cancel-account-body', $modal).addClass('d-none');
              $('.modal-footer', $modal).addClass('d-none');
              $('.modal-title', $modal).addClass('text-danger');
            } else {
              app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            }
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
          .setRequestData(requestData);


        appTransport.delete('/api/billing/cancel-subscription');
        return query.promise();
      };

      /**
       *
       * @returns {*}
       */
      _this.reinstateAccount = function () {
        var query = $.Deferred();
        var requestData = $('form[name="undo-cancel-account__form"]', $(context)).serializeObject();
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $('#UndoCancelAccountModal').modal('hide');
                app.redirect('/my-account/billing', true);
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
          .setRequestData(requestData);

        appTransport.put('/api/billing/reinstate-account');
        return query.promise();
      };

      _this.changeSubscription = function () {
        var query = $.Deferred();
        var $planModal = $('#PlanModal');
        var requestData = $('form[name="change-plan__form"]', $(context)).serializeObject();
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $planModal.modal('hide');
                app.redirect('/my-account/billing', true);
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            if (typeof error.message != 'undefined' && error.message.message == 'downgradeError') {
              $('.plan-change-error', $planModal).removeClass('d-none');
              $('.plan-change-body', $planModal).addClass('d-none');
              $('.modal-footer', $planModal).addClass('d-none');
              $('.modal-title', $planModal).addClass('text-danger');
            } else {
              app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            }
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
          .setRequestData(requestData);

        appTransport.post('/api/billing/change-subscription');
        return query.promise();
      };

      _this.getReceipt = function (receiptId) {
        var query = $.Deferred();
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response) {
                if (typeof response.url != 'undefined') {
                  window.location.href = response.url;
                  var $downloadIcon = $(
                    '<div class="animated infinite bounce delay-4s" ' +
                    'style="position: fixed; font-size: 40px; left: 100px; bottom: 50px;" >' +
                    '<i class="fas fa-download" ></i>' +
                    '</div>');
                  $downloadIcon.appendTo($('body'));
                  setTimeout(function () {
                    $downloadIcon.remove();
                  }, 4000);
                } else {
                  $receiptBody.html('');
                  var receipt = _.template(templates.receipt);
                  var $receipt = $(
                    receipt(
                      $.extend(response, {})
                    )
                  );
                  $receipt.appendTo($receiptBody);
                  $('#ReceiptModal', $(context)).modal('show');
                }
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {
          });

        appTransport.get('/api/billing/receipt/' + receiptId);
        return query.promise();
      };

      return {
        init: function () {
          // Load invoices
          _this.getInvoices();

          var $context = $(context);
          $('.card-js', $context).CardJs();

          var $cvcContainer = $('.cvc-container', $context);
          $('.cvv__help--container', $context).appendTo($cvcContainer);

          // Fetch all the forms we want to apply custom Bootstrap validation styles to
          var forms = $('form.needs-validation', $(context));
          // Loop over them and prevent submission
          var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
              if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
              } else {
                event.preventDefault();
                var $button = $(form).find('button[type=submit]');
                $button.button('loading');
                var formName = $(form).attr('name');

                if (formName == 'billing__form') {
                  $.when(_this.save()).done(function () {
                    $button.button('reset');
                  }).fail(function () {
                    $button.button('reset');
                  });
                }

                if (formName == 'cancel-account__form') {
                  $.when(_this.cancelSubscription()).done(function () {
                    $button.button('reset');
                  }).fail(function () {
                    $button.button('reset');
                  });
                }

                if (formName == 'undo-cancel-account__form') {
                  $.when(_this.reinstateAccount()).done(function () {
                    $button.button('reset');
                  }).fail(function () {
                    $button.button('reset');
                  });
                }

                if (formName == 'change-plan__form') {
                  $.when(_this.changeSubscription()).done(function () {
                    $button.button('reset');
                  }).fail(function () {
                    $button.button('reset');
                  });
                }
              }
              form.classList.add('was-validated');
            }, false);
          });


          $(document).off('click.billing__' + nameSpace).on('click.billing__' + nameSpace, context + ' [data-action]', function () {
            var $button = $(this);
            var action = $button.attr('data-action');
            var $context = $(context);
            var dataId = $button.attr('data-id');

            switch (action) {
              case 'update-credit-card' :
                $('.my-credit-card-view', $context).hide();
                $('.my-credit-card-edit', $context).show();
                break;

              case 'cancel-update-credit-card'   :
                $('.my-credit-card-edit', $context).hide();
                $('.my-credit-card-view', $context).show();
                break;

              case 'receipt' :
                $button.button('loading');
                $.when(_this.getReceipt(dataId)).done(function () {
                  $button.button('reset');
                }).fail(function () {
                  $button.button('reset');
                });
            }

          }).off('show.bs.modal').on('show.bs.modal', '[data-subscription-change-modal]', function () {
            var $planModal = $('[data-subscription-change-modal]');
            $('.plan-change-error', $planModal).addClass('d-none');
            $('.plan-change-body', $planModal).removeClass('d-none');
            $('.modal-footer', $planModal).removeClass('d-none');
            $('.modal-title', $planModal).removeClass('text-danger');
          }).off('show.bs.modal').on('show.bs.modal', '[data-cancel-account-modal]', function () {
            var $modal = $('[data-cancel-account-modal]');
            $('.cancel-account-error-body', $modal).addClass('d-none');
            $('.cancel-account-body', $modal).removeClass('d-none');
            $('.modal-footer', $modal).removeClass('d-none');
            $('.modal-title', $modal).removeClass('text-danger');
          });
        }
      }

    }

  });

})(PreBuilt);

